import { render, staticRenderFns } from "./ModeratorList.vue?vue&type=template&id=26fa7cd6&scoped=true&"
import script from "./ModeratorList.vue?vue&type=script&lang=js&"
export * from "./ModeratorList.vue?vue&type=script&lang=js&"
import style0 from "./ModeratorList.vue?vue&type=style&index=0&id=26fa7cd6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26fa7cd6",
  null
  
)

export default component.exports